import styled from 'styled-components';
import {
  LocationSectionBody,
} from '../../../../../../components/dialogs/edit-position-dialog/position-location-section/location-section-body/location-section-body.component';

export const Container = styled.div`
  
`;

export const LocationSection = styled(LocationSectionBody)`
  max-width: 660px;
`;
